export const CEMETERIES = [
  "Monte Cielo Eternal Gardens",
  "Golden Haven Memorial Park",
  "New Public Cemetery",
  "Old Public Cemetery",
];

export const BLESSING_DATES = [
  { value: "2026-10-31", day: "Saturday", label: "October 31", tag: "Eve of All Saints" },
  { value: "2026-11-01", day: "Sunday", label: "November 1", tag: "All Saints' Day" },
  { value: "2026-11-02", day: "Monday", label: "November 2", tag: "All Souls' Day" },
];

export const DONATION_AMOUNTS = [200, 500, 1000];

export const NOV2_MASSES = [
  { t: "6:00 AM", v: "New Public Cemetery" },
  { t: "8:00 AM", v: "Monte Cielo Eternal Gardens" },
  { t: "10:00 AM", v: "Golden Haven Memorial Park" },
  { t: "2:00 PM", v: "Old Public Cemetery" },
];

export const DONATION_QR = "/donation-qr.png";

export const fmtTime = (hhmm) => {
  if (!hhmm) return "—";
  const [h, m] = hhmm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const fmtDate = (iso) => BLESSING_DATES.find((d) => d.value === iso)?.label + ", 2026";

export const peso = (n) => `₱${Number(n).toLocaleString("en-PH")}`;

const manilaToday = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Manila" });
export const isTombSeason = () => manilaToday() <= "2026-11-02";
